import { render, staticRenderFns } from "./TemplateMappingTab.vue?vue&type=template&id=c59ab824&scoped=true&"
import script from "./TemplateMappingTab.vue?vue&type=script&lang=js&"
export * from "./TemplateMappingTab.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMappingTab.vue?vue&type=style&index=0&id=c59ab824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59ab824",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VDataTable,VDialog,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c59ab824')) {
      api.createRecord('c59ab824', component.options)
    } else {
      api.reload('c59ab824', component.options)
    }
    module.hot.accept("./TemplateMappingTab.vue?vue&type=template&id=c59ab824&scoped=true&", function () {
      api.rerender('c59ab824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Template/modal/TemplateMappingTab.vue"
export default component.exports